export const refuseEvent = {
    text: {
        message: "Vous êtes sur le point de refuser ce rdv et d'avertir votre patient de votre choix. {0}",
        strong: "Souhaitez-vous vraiment refuser ?"
    },
    refuse: {
        label: "Vous pouvez indiquer un message de refus",
        placeholder: "ex : désolé, ce créneau est déjà réservé"
    }
}